module.exports = __webpack_public_path__ + "static/media/viska-red@2x.ce73c45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/viska-red@2x.png
// module id = 112
// module chunks = 0